"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselBanner = void 0;
var CarouselBanner = /** @class */ (function () {
    function CarouselBanner() {
    }
    return CarouselBanner;
}());
exports.CarouselBanner = CarouselBanner;
//# sourceMappingURL=CarouselBanner.js.map